// App-wide sound + haptics preferences (persisted) and a vibration helper.
const SOUND_KEY = "naevo_mute";
const HAPTIC_KEY = "naevo_haptics";
const emit = () => window.dispatchEvent(new Event("naevo-fx-change"));

export const isMuted = () => { try { return localStorage.getItem(SOUND_KEY) === "1"; } catch { return false; } };
export const setMutedGlobal = (v) => { try { localStorage.setItem(SOUND_KEY, v ? "1" : "0"); } catch {} emit(); };
export const hapticsOn = () => { try { return localStorage.getItem(HAPTIC_KEY) !== "0"; } catch { return true; } };
export const setHaptics = (v) => { try { localStorage.setItem(HAPTIC_KEY, v ? "1" : "0"); } catch {} emit(); };
export const canVibrate = () => typeof navigator !== "undefined" && typeof navigator.vibrate === "function";
export const buzz = (pattern) => { if (hapticsOn() && canVibrate()) { try { navigator.vibrate(pattern); } catch {} } };
export const BUZZ = { win: [70], jackpot: [90, 50, 90, 50, 260], tap: [12] };
